import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const SET_BUY_PACKAGE_MESSAGE = 'BUY_PACKAGE :: MESSAGE';

interface IBuyPackageMessage {
  message: string;
}

export type TSetBuyPackageMessageAction = IReduxAction<typeof SET_BUY_PACKAGE_MESSAGE, IBuyPackageMessage>;

export const setBuyPackageMessage = actionGenerator<typeof SET_BUY_PACKAGE_MESSAGE, IBuyPackageMessage>(
  SET_BUY_PACKAGE_MESSAGE,
);
